export default function Mask() {
  return <div className="fixed left-0 top-0 z-50 h-screen w-screen" />;
}
